/** Mass-edit only these agreement fields (never report/product leftovers). */
export const AGREEMENT_MASS_EDIT_FIELDS = [
  "customer_id",
  "project_id",
  "agreement_type_id",
  "interval_id",
];

/** Expected API path for agreements list_update (Worker A / API). */
export const AGREEMENT_LIST_UPDATE_PATH = "/service/agreements/list";

export function normalizeAgreementIds(ids) {
  if (Array.isArray(ids)) {
    return ids.map(String).map((s) => s.trim()).filter(Boolean);
  }
  if (ids == null || ids === "") return [];
  return String(ids)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * Build PUT /api/v1/service/agreements/list body.
 * Only includes filled agreement fields so empty selectors do not wipe values.
 */
export function buildAgreementListUpdatePayload(values = {}) {
  const ids = normalizeAgreementIds(values.ids);
  const agreement = {};

  for (const key of AGREEMENT_MASS_EDIT_FIELDS) {
    const v = values[key];
    if (v === undefined || v === null || v === "" || v === "None") continue;
    agreement[key] = v;
  }

  return { ids, agreement };
}

export function agreementDisplayLabel(item) {
  if (!item) return "";
  return (
    item.displayTitle ||
    item.agreement_number ||
    (item.id != null ? `#${item.id}` : "")
  );
}

export function collectChangedMassEditFields(values = {}, fieldLabels = {}) {
  const changes = [];
  for (const key of AGREEMENT_MASS_EDIT_FIELDS) {
    const v = values[key];
    if (v === undefined || v === null || v === "" || v === "None") continue;
    changes.push({
      key,
      label: fieldLabels[key] || key,
      value: v,
    });
  }
  return changes;
}

export function summarizeListUpdateEvents(payload) {
  const events = payload?.events;
  if (!Array.isArray(events)) {
    return { okCount: null, failCount: null, total: null, events: [] };
  }
  const okCount = events.filter((e) => e?.success).length;
  const failCount = events.length - okCount;
  return { okCount, failCount, total: events.length, events };
}

/** True when an RTK dispatch result for listUpdate is a confirmed success. */
export function isAgreementListUpdateFulfilled(action) {
  if (!action || action.meta?.requestStatus !== "fulfilled") return false;
  const payload = action.payload;
  if (!payload || payload === false) return false;
  if (payload.isAxiosError) return false;
  if (payload.error || payload.errors) return false;
  if (typeof payload.status === "number" && payload.status >= 400) return false;
  if (payload.response?.status >= 400) return false;
  const summary = summarizeListUpdateEvents(payload);
  if (summary.failCount != null && summary.failCount > 0 && summary.okCount === 0) {
    return false;
  }
  return true;
}
